import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services';

/** Error codes that should NOT trigger automatic logout on 401 */
const SKIP_LOGOUT_ERROR_CODES = ['AUTHENTICATION_REQUIRED'];

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !error.url.includes('user/auth/password') && !error.url.includes('user/auth/sign_in')) {
          // Skip logout for specific error codes that require user action (e.g., sign in to continue)
          const errorCode = error.error?.code;
          if (!SKIP_LOGOUT_ERROR_CODES.includes(errorCode)) {
            this.authService.logOut();
          }
        }
        return throwError(Object.assign({}, error.error, { originError: error }));
      })
    );
  }
}
